import { RxStateComponent } from '@alliance/shared/models'
import { Component, ChangeDetectionStrategy, ViewContainerRef, AfterViewInit } from '@angular/core'
import { map } from 'rxjs'
import { CarouselService } from '@alliance/shared/carousel-gallery'
import { OnboardingCategoriesEnum } from '../../../domain/models/onboarding-categories.enum'
import { VisibilityStateService } from '../../../api'
import { CategoriesToComponentsMap } from '../constants/categories-to-components-map'

@Component({
  selector: 'lib-category-item',
  template: '',
  providers: [CarouselService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryItemComponent extends RxStateComponent<{ activeCategory: OnboardingCategoriesEnum | null }> implements AfterViewInit {
  public constructor(private visibilityStateService: VisibilityStateService, private viewContainerRef: ViewContainerRef) {
    super()

    this.initState({
      activeCategory: this.visibilityStateService.select('activeCategory')
    })
  }

  public ngAfterViewInit(): void {
    this.hold(
      this.select('activeCategory').pipe(
        map(activeCategory => {
          if (!activeCategory) {
            this.viewContainerRef?.clear()
            return
          }
          const item = CategoriesToComponentsMap[activeCategory]
          const component = this.viewContainerRef.createComponent(item)
          component.changeDetectorRef.detectChanges()
        })
      )
    )
  }
}
